import { useEffect, useMemo, useState } from 'react';
import { GlobalBus } from '@core/Bus/EventBus';

/**
 * Resolve a player avatar URL via the active game controller.
 * Re-renders when `player:avatar-changed` fires (e.g. CDN pool loaded or local pick updated).
 */
export function usePlayerAvatarUrl(
  playerId: string,
  resolveUrl?: (playerId: string) => string
): string {
  const [revision, setRevision] = useState(0);

  useEffect(() => {
    if (!resolveUrl) return;
    return GlobalBus.on('player:avatar-changed', () => {
      setRevision(value => value + 1);
    });
  }, [resolveUrl]);

  return useMemo(
    () => (playerId && resolveUrl ? resolveUrl(playerId) : ''),
    [playerId, resolveUrl, revision]
  );
}
